import moment from 'moment';
import React from 'react';

import {
    Button, message, Modal,
    Select
} from 'antd';

import { API_ENDPOINT, MKT_BASE_CURRENCY } from '../../index';

const { DELIVERY_MODES_PRETTY } = require('./config');

const { Option } = Select;

class DownloadListModal extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            selectedDeliveryMode: false,
            selectedLocationActionRequired: 'pickup',
            plannedForRoute: 'true'
        }
    }

    render() {

        return (
            <Modal
                title="Download List for Delivery Mode"
                onCancel={this.props.onCancel}
                centered
                visible={this.props.visible}
                footer={null}
                width='contain'
            >
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 2fr',
                        rowGap: 15
                    }}
                    >
                        <div style={{ paddingRight: 8 }}>Delivery Mode :</div>
                        <Select style={{ width: 250 }} onChange={(e) => this.setState({ selectedDeliveryMode: e }) }>
                            {Object.keys(DELIVERY_MODES_PRETTY)
                            .filter(_key => !['janio','lalamove'].includes(_key))
                            .map(_key => {
                                return (
                                    <Option value={_key}>{DELIVERY_MODES_PRETTY[_key]}</Option>
                                )
                            })}
                        </Select>
                        <div style={{ paddingRight: 8 }}>Action :</div>
                        <Select style={{ width: 250 }}
                            value={this.state.selectedLocationActionRequired}
                            onChange={(e) => this.setState({ selectedLocationActionRequired: e })}>
                            <Option value='pickup'>Pickup</Option>
                            <Option value='delivery'>Delivery</Option>
                        </Select>
                        <div style={{ paddingRight: 8 }}>Planned? :</div>
                        <Select style={{ width: 250 }}
                            value={this.state.plannedForRoute}
                            onChange={(e) => this.setState({ plannedForRoute: e })}>
                            <Option value='true'>Planned</Option>
                            <Option value='false'>Not Planned</Option>
                            <Option value='all'>All</Option>
                        </Select>

                    <Button
                        disabled={!this.state.selectedDeliveryMode}
                        size='large'
                        type='primary'
                        style={{
                            margin: '10px'
                        }}
                        icon='file-excel'
                        href={this.constructHref()}
                    >
                        Download
                    </Button>

                </div>

            </Modal>
        )
    }

    constructHref = () => {
        const { 
            selectedDeliveryMode,
            selectedLocationActionRequired,
            plannedForRoute
        } = this.state

        const dateFormatted = moment(this.props.date).format('YYYY-MM-DD')

        let href = `${API_ENDPOINT}/api/admin/delivery/csv-format/${selectedDeliveryMode}/${dateFormatted}?mktBaseCurrency=${MKT_BASE_CURRENCY}&locationActionRequired=${selectedLocationActionRequired}&plannedForRoute=${plannedForRoute}`
        return href
    }

}

export default DownloadListModal


// WEBPACK FOOTER //
// ./src/components/delivery-page/download-list-modal.js